import { faTable } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { GroupChartDataSet, TableRow as ngtTableRow } from "../../../api/dtos/dtos";
import StackedBarChart from "./StackedBarChart";
import NGTTable from "./NGTTable";

interface IChartsAndTablesCardProps {
    sightingTableData: ngtTableRow[] | undefined,
    damageTableData: ngtTableRow[] | undefined,
    controlTableData: ngtTableRow[] | undefined,
    sightingGroupChartDataSet: GroupChartDataSet[] | undefined,
    damageGroupChartDataSet: GroupChartDataSet[] | undefined,
    controlGroupChartDataSet: GroupChartDataSet[] | undefined,
    sightingGroupChartLabels: string[] | undefined,
    damageGroupChartLabels: string[] | undefined,
    controlGroupChartLabels: string[] | undefined,
}

const ChartsAndTablesCard: FC<IChartsAndTablesCardProps> = ({
    sightingTableData,
    damageTableData,
    controlTableData,
    sightingGroupChartDataSet,
    damageGroupChartDataSet,
    controlGroupChartDataSet,
    sightingGroupChartLabels,
    damageGroupChartLabels,
    controlGroupChartLabels,
}) => {

    return (
        <Card 
            variant='outlined'
            sx={{
                marginY: '15px'
            }}
        >
            <CardContent>
                <Grid container spacing={1} alignItems={"center"}>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems={"center"}>
                            <FontAwesomeIcon icon={faTable} style={{ fontSize: '1.2rem', paddingRight: "5px" }} />
                            <Typography paddingLeft={"5px"} fontSize={24}>
                                Tables
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <>
                    {sightingTableData && (
                        <>
                            <Box sx={{padding: "10px"}} />
                            <Box
                            id={"sighting-data"}
                                sx={{ 
                                    border: '2px solid #4cc61b',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Grid container spacing={1}>
                                    <Grid 
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {/** Table */}
                                        <NGTTable
                                            tableId={"sighting-table"}
                                            tableTitle={"Sighting Type"}
                                            tableRows={sightingTableData}
                                        />
                                    </Grid>
                                    <Grid 
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {/** Graph */}
                                        <StackedBarChart 
                                            graphId={"sighting-graph"}
                                            chartDataSet={sightingGroupChartDataSet} 
                                            chartLabels={sightingGroupChartLabels}    
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    )}

                    {damageTableData && (
                        <>
                            <Box sx={{padding: "10px"}} />
                            <Box
                            id={"damage-data"}
                                sx={{ 
                                    border: '2px solid #f23e3e',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Grid container spacing={1}>
                                    <Grid 
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            overflow: 'hidden'
                                        }}
                                    >
                                        {/** Table */}
                                        <NGTTable
                                            tableId={"damage-table"}
                                            tableTitle={"Damage Type"}
                                            tableRows={damageTableData}
                                        />
                                    </Grid>
                                    <Grid 
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {/** Graph */}
                                        <StackedBarChart
                                            graphId={"damage-graph"}
                                            chartDataSet={damageGroupChartDataSet} 
                                            chartLabels={damageGroupChartLabels}    
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    )}

                    {controlTableData && (
                        <>
                            <Box sx={{padding: "10px"}} />
                            <Box
                                id={"control-data"}
                                sx={{ 
                                    border: '2px solid #0300e0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Grid container spacing={1}>
                                    <Grid 
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            overflow: 'hidden'
                                        }}
                                    >
                                        {/** Table */}
                                        <NGTTable
                                            tableId={"control-table"}
                                            tableTitle={"Control Type"}
                                            tableRows={controlTableData}
                                        />
                                    </Grid>
                                    <Grid 
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {/** Graph */}
                                        <StackedBarChart
                                            graphId={"control-graph"}
                                            chartDataSet={controlGroupChartDataSet} 
                                            chartLabels={controlGroupChartLabels}    
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    )}
                </>
            </CardContent>
        </Card>
    )
}

export default ChartsAndTablesCard